export default __webpack_public_path__ + "static/media/Path3395.cffcfd04.svg";